import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=2d33c684&scoped=true&"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmation.vue?vue&type=style&index=0&id=2d33c684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33c684",
  null
  
)

export default component.exports